import Box from '@mui/material/Box';
import { Theme } from '@mui/material/styles';
import { SystemStyleObject } from '@mui/system';

import barChannelLogo from 'assets/images/brand/bar-channel-logo.png';

export type BarChannelLogoVariant = 'sidebar-expanded' | 'sidebar-mini' | 'auth';

const VARIANT_SX: Record<BarChannelLogoVariant, SystemStyleObject<Theme>> = {
  'sidebar-expanded': {
    display: 'block',
    width: '100%',
    maxWidth: 232,
    height: 'auto',
    maxHeight: 64,
    objectFit: 'contain',
    objectPosition: 'left center'
  },
  'sidebar-mini': {
    display: 'block',
    width: 56,
    height: 56,
    maxWidth: 56,
    mx: 'auto',
    objectFit: 'contain',
    objectPosition: 'center'
  },
  auth: {
    display: 'block',
    width: 240,
    maxWidth: '100%',
    height: 'auto',
    maxHeight: 72,
    mx: 'auto',
    objectFit: 'contain',
    objectPosition: 'center'
  }
};

interface Props {
  variant?: BarChannelLogoVariant;
  sx?: SystemStyleObject<Theme>;
}

// ==============================|| BARCHANNEL LOGO ||============================== //

export default function BarChannelLogo({
  variant = 'sidebar-expanded',
  sx
}: Readonly<Props>) {
  return (
    <Box
      component="img"
      src={barChannelLogo}
      alt="BarChannel"
      sx={{ ...VARIANT_SX[variant], ...sx }}
    />
  );
}
